/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Total_JobsInputs */

const en_usage_total_jobs = /** @type {(inputs: Usage_Total_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Jobs`)
};

const fr_usage_total_jobs = /** @type {(inputs: Usage_Total_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre total d'emplois`)
};

const de_usage_total_jobs = /** @type {(inputs: Usage_Total_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtzahl der Arbeitsplätze`)
};

const it_usage_total_jobs = /** @type {(inputs: Usage_Total_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totale posti di lavoro`)
};

const ru_usage_total_jobs = /** @type {(inputs: Usage_Total_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общее количество рабочих мест`)
};

const es_usage_total_jobs = /** @type {(inputs: Usage_Total_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de empleos`)
};

const zh_cn2_usage_total_jobs = /** @type {(inputs: Usage_Total_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总职位`)
};

const ja_usage_total_jobs = /** @type {(inputs: Usage_Total_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合計ジョブ数`)
};

const hi_usage_total_jobs = /** @type {(inputs: Usage_Total_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुल नौकरियाँ`)
};

const pt_pt2_usage_total_jobs = /** @type {(inputs: Usage_Total_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de empregos`)
};

/**
* | output |
* | --- |
* | "Total Jobs" |
*
* @param {Usage_Total_JobsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_total_jobs = /** @type {((inputs?: Usage_Total_JobsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Total_JobsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_usage_total_jobs(inputs)
	if (locale === "de") return de_usage_total_jobs(inputs)
	if (locale === "it") return it_usage_total_jobs(inputs)
	if (locale === "ru") return ru_usage_total_jobs(inputs)
	if (locale === "es") return es_usage_total_jobs(inputs)
	if (locale === "zh-CN") return zh_cn2_usage_total_jobs(inputs)
	if (locale === "ja") return ja_usage_total_jobs(inputs)
	if (locale === "hi") return hi_usage_total_jobs(inputs)
	if (locale === "pt-PT") return pt_pt2_usage_total_jobs(inputs)
	return en_usage_total_jobs(inputs)
});